"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _contains = _interopRequireDefault(require("lodash/fp/contains"));
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
var _eventHandler = require("@active/react-utils/eventHandler");
var _CheckboxGroup = require("../CheckboxGroup");
var _utils = require("../Form/utils");
var _excluded = ["onChange", "onTouched", "onBlur", "onKeyDown"],
  _excluded2 = ["value", "onChange"],
  _excluded3 = ["children", "className", "disabled", "hasError", "indeterminate", "size", "style", "onClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Checkbox = function Checkbox(_ref, ref) {
  var propOnChange = _ref.onChange,
    propOnTouched = _ref.onTouched,
    propOnBlur = _ref.onBlur,
    propOnKeyDown = _ref.onKeyDown,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_CheckboxGroup.CheckboxGroupContext),
    ctxValue = _useContext.value,
    ctxOnChange = _useContext.onChange,
    ctx = (0, _objectWithoutProperties2["default"])(_useContext, _excluded2);
  var calcProps = _objectSpread(_objectSpread({
    checked: (0, _isNil["default"])(ctxValue) ? undefined : (0, _contains["default"])(props.value)(ctxValue)
  }, ctx), props);
  var children = calcProps.children,
    className = calcProps.className,
    disabled = calcProps.disabled,
    hasError = calcProps.hasError,
    indeterminate = calcProps.indeterminate,
    size = calcProps.size,
    style = calcProps.style,
    onClick = calcProps.onClick,
    rest = (0, _objectWithoutProperties2["default"])(calcProps, _excluded3);
  var handleClick = (0, _react.useCallback)(function (e) {
    propOnTouched === null || propOnTouched === void 0 || propOnTouched();
    onClick === null || onClick === void 0 || onClick(e);
  }, [propOnTouched, onClick]);
  var handleChange = (0, _react.useCallback)(function (e) {
    ctxOnChange === null || ctxOnChange === void 0 || ctxOnChange(e);
    propOnChange === null || propOnChange === void 0 || propOnChange(e);
  }, [ctxOnChange, propOnChange]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    propOnBlur === null || propOnBlur === void 0 || propOnBlur(e);
  }, [propOnBlur]);
  var handleKeyDown = (0, _eventHandler.useOnKeyboardConfirm)(function (e) {
    var ele = e;
    var target = e.target;
    target.checked = !target.checked;
    handleChange(ele);
    propOnKeyDown === null || propOnKeyDown === void 0 || propOnKeyDown(e);
  }, [handleChange, propOnKeyDown]);
  return /*#__PURE__*/_react["default"].createElement("label", {
    "data-testid": "checkbox-root",
    className: (0, _classnames["default"])('checkbox', (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, "checkbox-".concat(size), size && size !== 'md'), "indeterminate", indeterminate), 'has-error', hasError), "disabled", disabled), className),
    style: style
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "checkbox-input"
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    ref: ref,
    "data-testid": "checkbox",
    disabled: disabled,
    type: "checkbox",
    onBlur: handleBlur,
    onChange: handleChange,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    "data-checked": rest.checked
  }, (0, _utils.omitFormProps)(rest))), /*#__PURE__*/_react["default"].createElement("span", {
    className: "checkbox-inner",
    "aria-hidden": "true"
  })), children ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "checkbox-label"
  }, children) : /*#__PURE__*/_react["default"].createElement("span", {
    "data-testid": "label-wcag",
    style: {
      display: 'none'
    }
  }, "LABEL_WCAG"));
};
var Composed = (0, _compose["default"])(_react.memo, _react["default"].forwardRef)(Checkbox);
var _default = exports["default"] = Composed;